import type { PackageStatus } from '../../types/packages';
import { PACKAGE_STATUS_BADGE, PACKAGE_STATUS_LABELS } from './packageReviewModel';

export interface PackageStatusChipProps {
  status: PackageStatus;
}

export default function PackageStatusChip(props: PackageStatusChipProps) {
  const { status } = props;
  return <span className={`admin-badge ${PACKAGE_STATUS_BADGE[status] ?? 'neutral'}`}>{PACKAGE_STATUS_LABELS[status] ?? status}</span>;
}
